import moment from 'moment';

export default {
  data: () => ({
    dialog: false,
    dates: [],
    modalDate: false,
    textField: null,
    dateRange: null
  }),
  computed: {
    dateRangeText(){
      return this.dates.join(' ~ ');
    }
  },
  mounted(){
    const queryString = this.$route.query;
    if (queryString.text) this.textField = queryString.text;
    if (queryString.start && queryString.end){
      const date = [
        queryString.start,
        queryString.end
      ];
      this.dates = date;
    }
  },
  methods: {
    moment,
    handleSearch(e){
      e.preventDefault();
      let startDate;
      let endDate;
      if (this.dates[0]) startDate = moment(this.dates[0]).format('YYYY-MM-DD');
      if (this.dates[1]) endDate = moment(this.dates[1]).format('YYYY-MM-DD');
      this.$router.push({ name: 'Order', query: { text: this.textField, start: startDate, end: endDate } });
    },
    handleResetData(){
      this.textField = null;
      this.dates = [];
      this.$router.push({ name: 'Order' });
    }
  }
};
